import { RenderingContext } from './../../../../../../api';
import { freezeDeep } from './../../../../../../utils';
import { EMPTY_SITE_CONTEXT } from './../../site/site.context';

export const EMPTY_RENDERING_CONTEXT: RenderingContext = freezeDeep({
    id: '00000000-0000-0000-0000-000000000000',
    elements: {},
    layouts: {},
    markups: {},
    context: EMPTY_SITE_CONTEXT
});
